export default "__VITE_ASSET__TaGFlZMm__"